import { TrendingUp } from "lucide-react";
import PageHeader from "@/layout/PageHeader";

export default function MonthlyTrends() {
  return (
    <div data-testid="monthly-trends-page">
      <PageHeader title="Monthly Trends" subtitle="Coming soon." />
      <div className="hm-surface p-12 text-center" data-testid="monthly-trends-empty">
        <TrendingUp className="h-6 w-6 text-hm-fg-subtle mx-auto mb-3" />
        <div className="text-sm text-hm-fg-muted">
          The 30-day trend line across every monitored topic and region. Not
          wired yet.
        </div>
      </div>
    </div>
  );
}
